module.exports = __webpack_public_path__ + "img/portrait-066.05d8163c.jpg";